import { Expose, Exclude } from 'class-transformer';

@Exclude()
export class Measurement {
  @Expose()
  measurementId: number;

  @Expose()
  animalId: number;

  @Expose()
  traitCode: string;

  @Expose()
  measurementDate: string;

  @Expose()
  createDate: string;

  @Expose()
  modifyDate: string;

  @Expose()
  value: string;

  @Expose()
  previousValue: string;

  @Expose()
  thresholdFlag: number;

  @Expose()
  siteCode: string;

  @Expose()
  sourceSystemId: string;

  @Expose()
  sourceFileId: string;

  @Expose()
  device: string;

  @Expose()
  reason: string;
}
